import { Injectable } from '@angular/core';
import { HttpClient } from 'src/shared/providers/http/http-client';

@Injectable()
export class Credentials {

  constructor(private httpClient: HttpClient) {}

  getCredentials(): Promise<CredentialModel[]> {
    const url = 'api/v1/homekeeper/credentials';
    return this.httpClient.get(url);
  }

  getCredentialTypes(): Promise<CredentialTypeModel[]> {
    const url = 'api/v1/homekeeper/credential-types';
    return this.httpClient.get(url);
  }

  addCredential(data: AddCredentialParams): Promise<CredentialModel> {
    const url = 'api/v1/homekeeper/credentials';
    return this.httpClient.post(url, data);
  }

  deleteCredential(id: number): Promise<CredentialModel> {
    const url = `api/v1/homekeeper/credentials/${id}`;
    return this.httpClient.delete(url);
  }
}

export interface CredentialTypeModel {
  key: string;
  category: string;
  key_label: string;
  category_label: string;
  form_options: Record<string, any>;
}

export interface CredentialModel {
  id: number;
  credential_type: CredentialTypeModel;
  text_value: string;
  file_url: string;
  status: string;
  rejection_reason: string;
  created_at: string;
  reviewed_at: string;
}

export interface AddCredentialParams {
  credential_type_key: string;
  text_value?: string;
  file_url?: string;
}
